/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BankBilletViewModel } from "../types/BankBilletViewModel.ts";

export const bankBilletViewModelSchema = z.object({
  courseFinPersonPaymentId: z.optional(z.number().int()),
  bankBook: z.string().nullish(),
  expireDate: z.optional(z.string().datetime()),
  value: z.optional(z.number()),
  fineValue: z.optional(z.number()),
  interestValue: z.optional(z.number()),
  totalValue: z.optional(z.number()),
  processDate: z.optional(z.string().datetime()),
  documentNumber: z.string().nullish(),
  bankCode: z.string().nullish(),
  branchCode: z.string().nullish(),
  branchDigit: z.string().nullish(),
  accountNumber: z.string().nullish(),
  accountDigit: z.string().nullish(),
  transferorCode: z.string().nullish(),
  transferorDocument: z.string().nullish(),
  transferorName: z.string().nullish(),
  payerDocument: z.string().nullish(),
  payerName: z.string().nullish(),
  payerEmail: z.string().nullish(),
  userId: z.optional(z.number().int()),
  parcelNumber: z.optional(z.number().int()),
  customerCode: z.string().nullish(),
  projectCode: z.string().nullish(),
  customerId: z.optional(z.number().int()),
  customerEmail: z.string().nullish(),
  customerAddress: z.string().nullish(),
  customerDistrict: z.string().nullish(),
  customerCity: z.string().nullish(),
  customerZipCode: z.string().nullish(),
  customerState: z.string().nullish(),
  userLanguage: z.string().nullish(),
  instructions: z.array(z.string()).nullish(),
  siglaState: z.string().nullish(),
  finePorcentage: z.optional(z.number()),
  interestPorcentage: z.optional(z.number()),
  discount: z.optional(z.number()),
  extendedExpirationDate: z.string().datetime().nullish(),
  digitableLine: z.string().nullish(),
  pdfFileUrl: z.string().nullish(),
  paymentMethod: z.optional(z.number().int()),
  pixQRCode: z.string().nullish(),
  pixCopyCode: z.string().nullish(),
  billetUrl: z.string().nullish(),
  hybridBilletUrl: z.string().nullish(),
  pixBilletUrl: z.string().nullish(),
  billetId: z.string().nullish(),
  orderId: z.string().nullish(),
  forceBilletPecegePay: z.optional(z.boolean()),
}) as unknown as ToZod<BankBilletViewModel>;
